const VoucherProgramFormResources = {
    headerCreateVoucherProgram: 'Add Voucher Program',
    headerEditVoucherProgram: 'Edit Voucher Program',
    headerViewVoucherProgram: 'View Voucher Program',
};
export default VoucherProgramFormResources;
